/**
 * 時間前市場 連系線空容量取得 hook。
 */
import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listBiddingInterconnectionCapacities } from '@ebalance/proto/bffuser/v1/bidding_intraday_market_service-BiddingIntradayMarketService_connectquery'
import {
  ListBiddingInterconnectionCapacitiesRequestSchema,
  type ListBiddingInterconnectionCapacitiesResponse,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_market_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export function useMarketInterconnectionCapacities(
  deliveryDate: ProtoDate | undefined,
  timeCode: number,
  enabled: boolean,
): UseQueryResult<ListBiddingInterconnectionCapacitiesResponse, ConnectError> {
  return useQuery(
    listBiddingInterconnectionCapacities,
    create(ListBiddingInterconnectionCapacitiesRequestSchema, {
      deliveryDate,
      timeCode,
    }),
    {
      enabled: enabled && deliveryDate !== undefined && timeCode > 0,
      staleTime: Infinity,
      // backend gRPC 未接続でも error boundary に飛ばさず、 呼び出し側でローディング表示。
      throwOnError: false,
      refetchInterval: (query) =>
        query.state.status === 'error' ? 5000 : false,
    },
  )
}
